import cimg from '../Images/home.svg';
const StudymaterialCardData = [{
        id: 1,
        type: "Complete Courses",
        sname: "Physics",
        subthumbnail: cimg,
        lname: "this is Complete Courses Give Tests based on different courses choosen by you anytime and get full detailed analysis.",
    },
    {
        id: 2,
        type: "Module-wise Courses",
        sname: "Maths",
        subthumbnail: cimg,
        lname: "this is Module-wise Courses Give Tests based on dlysis.",
    },
    {
        id: 3,
        type: "Chapter-wise Courses",
        sname: "Maths",
        subthumbnail: cimg,
        lname: "this is Chapter-wise Courses Give Tests based on different courses choosen by you anytime and get full detailed analysis.",
    },
    {
        id: 4,
        type: "Crash Courses",
        sname: "Physics",
        subthumbnail: cimg,
        lname: "this is Crash Courses Give Tests based on different courses choosen by you anytime and get full detailed analysis.",
    },
    {
        id: 5,
        type: "Crash Courses",
        sname: "Chemistry",
        subthumbnail: cimg,
        lname: "this is Crash Courses Give Tests based on different courses choosen by you anytime and get full detailed analysis.",
    },
];
export default StudymaterialCardData;